export default class TranslateApi {
    /**
     * This function will translate a given key into text using the current language
     *
     * **THIS FUNCTION IS ONLY TO BE USED IN PHASER**
     */
    public static translate: (key: string) => string;
    public static currentLanguage: { code: string } = { code: "en-us" };
}



// WEBPACK FOOTER //
// ./src/utils/TranslateHelper.ts